import { isoDate } from "@core/foundation/date";
import {
  createModel,
  createModelSchemas,
  noModelUpdate,
} from "@core/foundation/model";
import { z } from "@core/zod";

import { UserIdSchema } from "./user.ts";

const IdentifierTypeSchema = z.enum(["email", "service"]);

export type IdentifierType = z.infer<typeof IdentifierTypeSchema>;

export const Identity = createModel({
  create: item => {
    return { ...item, createdAt: isoDate() };
  },
  schemas: createModelSchemas({
    model: z.object(
      {
        createdAt: z.iso.datetime(),
        identifier: z.union([z.safeId(), z.email()]),
        identifierType: IdentifierTypeSchema,
        userId: UserIdSchema,
      },
      {
        createdAt: "When the identity was created, as an ISO 8601 timestamp.",
        identifier:
          "The email address or service id that signs in as the user.",
        identifierType: "The kind of identifier, either email or service.",
        userId: "The id of the user the identifier signs in as.",
      },
    ),
    modelCreate: ({ readSchema }) => readSchema.omit({ createdAt: true }),
    modelUpdate: noModelUpdate,
  }),
  update: (item, update, schema) => {
    return { ...item, ...schema.decode(update) };
  },
});

export interface Identity extends z.infer<typeof Identity.schema> {}
